import * as localStorage from "../lib/localStorage";

export enum contactType {
    known = "KNOWN",
    unknown = "UNKNOWN",
}

export interface contactFilterParam {
    contactType: contactType;
}
export function contactFilter(param: contactFilterParam) {
    let scope = "contactFilter";
    if (window.location.search != "") {
        let queryParameters = location.search.substring(1);
        let paramArray = queryParameters.split("&");
        let actualID;
        for (let i = 0; i < paramArray.length; i++) {
            if (paramArray[i].toLowerCase().includes("ug_cid")) {
                actualID = paramArray[i].split("=");
                localStorage.setItem(scope, "contactId", actualID[1]);
                return true;
            }
        }
        return false;
    } else if (localStorage.getItem(scope, "contactId") != null) {
        return true;
    } else {
        return false;
    }
}
